module.exports = __webpack_public_path__ + "bd5eef55374e839dc1736860674097ab.jpg";


//////////////////
// WEBPACK FOOTER
// ./demo/img/trainingarticle_3.jpg
// module id = 306
// module chunks = 0